// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__7fz_N","inputWrap":"CustomTip_inputWrap__3df8p"};